import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type QuickLinkProps = {
    text: string | null
    icon: string | null
    url: string
    accessibilityText: string
    templating: {mainTemplate: string; fallbackTemplate: string}
    ComponentName
}

export const QuickLink = memo(({text, url, icon, accessibilityText, templating}: QuickLinkProps) => {
    const ComponentName = useTemplatedComponent(templating, MANIFEST)
    return (
        <Suspense>
            <ComponentName text={text} url={url} icon={icon} accessibilityText={accessibilityText} />
        </Suspense>
    )
})
QuickLink.displayName = "QuickLink"

export default connect(QuickLink)
